import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

export default {
  init() {
    console.log('home');

    var root = document.documentElement;
    var whichDeviceType = window.innerWidth >= 768 ? 'isDesktop' : 'isMobile';
    var tl;
    const productions = gsap.utils.toArray('.production');
    const navLinks = gsap.utils.toArray('header ul li ul a');

    // disable blur on circle for other browsers not chromeium based
    if (!jQuery.browser.match(/chrome|edge|chromium based edge (dev or canary)/)) {
      jQuery('mask circle').attr('filter', null);
    }

    if (whichDeviceType === 'isDesktop') {
      desktopTimeline();
    } else {
      mobileTimeline();
    }

    window.addEventListener('resize', function () {
      if (whichDeviceType === 'isDesktop' && window.innerWidth < 1200) {
        mobileTimeline();
        whichDeviceType = 'isMobile';
      } else if (whichDeviceType === 'isMobile' && window.innerWidth >= 1200) {
        desktopTimeline();
        whichDeviceType = 'isDesktop';
      }
    });

    function mobileTimeline() {
      if (tl) tl.kill();
      gsap.set('section > article', {
        height: 'auto',
      });
      gsap.set('.transition image', {
        attr: { width: '120%', height: '120%', x: '-10%', y: '-10%' },
      });
      gsap.set('[href] > span span:last-child', {
        width: 0,
      });
      gsap.set('.production-card', {
        opacity: 1,
        translateY: 0,
      });

      navLinks.forEach((a) => {
        a.removeEventListener('click', scrollToNavLink);
        a.addEventListener('click', scrollToHash);
      });
    }

    function desktopTimeline() {
      gsap.set('section > article', {
        height: productions.length * (window.innerHeight - 1) * 1.5,
      });

      if (document.scrollingElement.scrollTop > window.innerHeight) {
        gsap.set('.production:first-child .production-card', { opacity: 1 });
      }

      tl = gsap.timeline({
        scrollTrigger: {
          trigger: '#productions',
          start: 'top',
          end: 'bottom+=' + window.innerHeight * (productions.length - 1) * 1.5,
          scrub: 0.5,
          invalidateOnRefresh: true,
        },
        defaults: {
          ease: 'power3',
        },
      });

      productions.forEach((prod, index, arr) => {
        const currentAnchor = document.querySelector(`[href$='#${prod.id}/']`);

        if (index === 0) {
          tl.addLabel(`#${prod.id}`);
          gsap.to('.production:first-child .production-card', {
            opacity: 1,
            duration: 0.5,
            delay: 0.5,
            ease: 'linear',
          });

          currentAnchor.setAttribute('aria-selected', 'true');

          tl.fromTo(
            `[href$='#${prod.id}/'] > span span:last-child`,
            {
              width: '100%',
            },
            {
              width: '0%',
              ease: 'linear',
              duration: 1,
              onComplete: () => currentAnchor.setAttribute('aria-selected', 'false'),
              onReverseComplete: () => currentAnchor.setAttribute('aria-selected', 'true'),
            },
            `<`,
          );
        }

        if (index > 0) {
          tl.to(
            `#${prod.id}`,
            {
              zIndex: 0,
            },
            '<',
          )
            .fromTo(
              `#transition-mask-${prod.id} circle`,
              {
                attr: { r: 0 },
              },
              {
                attr: { r: window.innerWidth * 0.8 },
                ease: 'linear',
                duration: 15,
              },
              '<',
            )
            .fromTo(
              `#transition-${prod.id} image`,
              {
                attr: { width: '50%', height: '50%', x: '25%', y: '25%' },
              },
              {
                attr: { width: '120%', height: '120%', x: '-10%', y: '-10%' },
                duration: 15,
              },
              '<',
            )
            .fromTo(
              `#filter-${prod.id} feGaussianBlur`,
              {
                attr: { stdDeviation: 1 },
              },
              {
                attr: { stdDeviation: 40 },
                duration: 20,
              },
              '<',
            )
            .fromTo(
              `#${prod.id} .production-card`,
              {
                opacity: 0,
                translateY: 10,
              },
              {
                opacity: 1,
                translateY: 0,
                duration: 2,
                ease: 'linear',
              },
              '>-50%',
            )

            .addLabel(`#${prod.id}`, '>')
            .to(
              `[href$='#${prod.id}/'] > span span:last-child`,
              {
                onStart: () => {
                  currentAnchor.setAttribute('aria-selected', 'true');
                  root.style.setProperty('--theme-gradient', `var(--theme-${prod.id}-gradient)`);
                },
                onReverseComplete: () => currentAnchor.setAttribute('aria-selected', 'false'),
              },
              `#${prod.id}-=9`,
            )
            .fromTo(
              `[href$='#${prod.id}/'] > span span:last-child`,
              {
                width: '0%',
              },
              {
                width: '100%',
                duration: 9,
                ease: 'linear',
              },
              `#${prod.id}-=9`,
            );
        }

        if (index < arr.length - 1) {
          tl.to(
            `#${prod.id} .production-card`,
            {
              opacity: 0,
              duration: 1.5,
              translateY: -10,
              ease: 'linear',
            },
            index ? '>+8' : 0.5,
          )
            .fromTo(
              `#transition-${prod.id} image`,
              {
                attr: { width: '120%', height: '120%', x: '-10%', y: '-10%' },
              },
              {
                attr: { width: '290%', height: '290%', x: '-95%', y: '-95%' },
                ease: 'linear',
                duration: 15,
              },
            )
            .to(
              `[href$='#${prod.id}/'] > span span:last-child`,
              {
                onStart: () => currentAnchor.setAttribute('aria-selected', 'false'),
                onReverseComplete: () => {
                  currentAnchor.setAttribute('aria-selected', 'true');
                  root.style.setProperty('--theme-gradient', `var(--theme-${prod.id}-gradient)`);
                },
              },
              '<',
            );

          if (index > 0) {
            tl.to(
              `[href$='#${prod.id}/'] > span span:last-child`,
              {
                width: '0%',
                duration: 1,
                ease: 'linear',
              },
              '<',
            );
          }
        }

        if (index === arr.length - 1) {
          tl.addLabel('#end');
        }
      });

      navLinks.forEach((a) => {
        a.removeEventListener('click', scrollToHash);
        a.addEventListener('click', scrollToNavLink);
      });
    }

    function scrollToNavLink(e) {
      e.preventDefault();
      const st = tl.scrollTrigger;
      const delta = 2;
      const labelTimestamp = tl.labels[this.hash.replace('/', '')];
      const percentMinusDelta = (labelTimestamp - delta) / tl.totalDuration();
      const percent = labelTimestamp / tl.totalDuration();
      const scrollPosMinusDelta = st.start + (st.end - st.start) * percentMinusDelta;
      const scrollPos = st.start + (st.end - st.start) * percent;

      const deltaProgress = Math.abs(tl.progress() * tl.totalDuration() - labelTimestamp);

      if (scrollPosMinusDelta <= 0) {
        gsap.to(window, { duration: 0, scrollTo: { y: scrollPosMinusDelta, autoKill: true } });
        tl.time(labelTimestamp - delta);
        gsap.fromTo(
          '.production:first-child .production-card',
          {
            opacity: 0,
            translateY: 10,
          },
          {
            opacity: 1,
            translateY: 0,
            duration: 0.55,
            ease: 'linear',
          },
        );
      } else if (deltaProgress < 23) {
        gsap.to(window, { duration: 1.25, scrollTo: { y: scrollPos, autoKill: true } });
      } else {
        gsap.to(window, { duration: 0, scrollTo: { y: scrollPosMinusDelta, autoKill: true } });
        tl.time(labelTimestamp - delta);
        gsap.to(window, { duration: 0.15, scrollTo: { y: scrollPos, autoKill: true } });
      }
    }

    function scrollToHash(e) {
      e.preventDefault();
      document.querySelector('.nav-toggle').click();
      document.getElementById(this.hash.replace('#', '').replace('/', '')).scrollIntoView();
    }
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};
